import { isApiError } from '@onefootprint/fetch-dashboard';
import type { Investigation } from '@onefootprint/request-types/dashboard';

export type RunOutcome = 'wait' | 'forget' | 'notify';

export const errorStatus = (error: unknown): number => {
  if (isApiError(error)) return error.status;
  return 0;
};

// A statusless investigation is a chat's own workspace, not a run. Only a 404 says the id will never
// resolve here; any other error is worth another poll.
export const runOutcome = (result: { data?: Investigation; error?: unknown }): RunOutcome => {
  if (errorStatus(result.error) === 404) return 'forget';
  if (!result.data) return 'wait';
  if (!result.data.status) return 'forget';
  if (result.data.status === 'pending') return 'wait';
  return 'notify';
};
